export default "../css/765109b598477339e532f1e8644a7777.ttf";